var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5654 10.3279L11.0239 0.229981C10.9552 0.157078 10.8736 0.099239 10.7838 0.059776C10.694 0.0203129 10.5977 0 10.5004 0C10.4032 0 10.3069 0.0203129 10.2171 0.059776C10.1272 0.099239 10.0456 0.157078 9.97692 0.229981L0.435491 10.3279C0.157518 10.6224 0 11.0222 0 11.4393C0 12.3053 0.664819 13.0095 1.48252 13.0095H2.48786V20.2149C2.48786 20.6492 2.81911 21 3.22912 21H9.01791V15.5045H11.6123V21H17.7717C18.1818 21 18.513 20.6492 18.513 20.2149V13.0095H19.5183C19.9121 13.0095 20.2897 12.8451 20.5677 12.5482C21.1445 11.9349 21.1445 10.9413 20.5654 10.3279Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8e3a219c6446bc6e43cb0d105b9a6d5e.svg";
export { ForwardRef as ReactComponent };